<template>
  <div class="div" v-loading="loading">
    <div class="div-top">
      <el-input
        v-model="searchData.Code"
        clearable
        placeholder="请输入设备编号或名称"
        style="width: 300px; margin-left: 10px"
      ></el-input>
      <el-date-picker
        v-model="searchData.RecordDate"
        type="monthrange"
        style="width: 300px; margin-left: 10px"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="handleDateChange"
      >
      </el-date-picker>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
      <el-button
        type="warning"
        @click="handleExport"
        style="margin-left: 10px"
        icon="el-icon-download"
        >导出数据</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        @selection-change="handleSelect"
      >
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>
        <el-table-column label="设备编号" align="center" prop="DeviceCode">
        </el-table-column>
        <el-table-column label="设备名称" align="center" prop="device_name">
        </el-table-column>
        <el-table-column label="供应商" align="center" prop="SupplierName">
        </el-table-column>
        <el-table-column label="维修日期" align="center" prop="RecordDate">
          <template slot-scope="scope">
            {{
              scope.row.RecordDate
                ? moment(scope.row.RecordDate).format('YYYY-MM-DD')
                : ''
            }}
          </template>
        </el-table-column>

        <el-table-column label="维修人员" align="center" prop="RealName">
        </el-table-column>
        <el-table-column label="工单编号" align="center" prop="Code">
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <ViewForm ref="ViewForm"></ViewForm>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import ViewForm from '@/views/Operation/OperationWorkOrder/ViewForm.vue'
import tools from '@/utils/tools.js'
export default {
  data() {
    return {
      moment,
      searchData: {
        Code: '',
        RecordDate: [],
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {
    workOrderType: {
      type: String,
      default: '',
    },
  },
  components: { ViewForm },
  methods: {
    handleDateChange(value) {
      // 无论是否为同一个月，结束日期都应为月末日期
      if (value && value.length === 2) {
        const startDate = moment(value[0])
        const endDate = moment(value[1])
        // 设置开始日期为选择月份的第一天
        const firstDay = startDate.startOf('month').format('YYYY-MM-DD')
        // 设置结束日期为选择月份的最后一天
        const lastDay = endDate.endOf('month').format('YYYY-MM-DD')
        this.$set(this.searchData, 'RecordDate', [firstDay, lastDay])
      }
    },
    handleExport() {
      tools.download(
        this.$rootUrl +
          `/Base_DeviceTreeManage/Device_MaintenanceRecord/ExportToExcel?DeviceType=${
            this.devTreeSearch.DeviceType || ''
          }&BuildingId=${
            this.devTreeSearch.BuildingId || ''
          }&InstallationArea=${
            this.devTreeSearch.InstallationArea || ''
          }&Code=${this.searchData.Code}&RecordDate=${
            this.searchData.RecordDate
              ? this.searchData.RecordDate.join(',')
              : ''
          }`,
        '维修记录',
        '.xlsx',
        'get'
      )
    },
    selectable(row) {
      if (row.State == '0') {
        return true
      } else {
        return false
      }
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post(
          '/Base_DeviceTreeManage/Device_MaintenanceRecord/GetMaintenanceRecordDataList',
          {
            PageIndex: this.pagination.PageIndex,
            PageRows: this.pagination.PageRows,
            SortField: 'RecordDate',
            SortType: 'Desc',
            Search: [
              {
                Condition: 'DeviceType',
                Keyword: this.devTreeSearch.DeviceType || '',
              },
              {
                Condition: 'BuildingId',
                Keyword: this.devTreeSearch.BuildingId || '',
              },
              {
                Condition: 'InstallationArea',
                Keyword: this.devTreeSearch.InstallationArea || '',
              },
              {
                Condition: 'Code',
                Keyword: this.searchData.Code,
              },
              {
                Condition: 'RecordDate',
                Keyword: this.searchData.RecordDate
                  ? this.searchData.RecordDate.join(',')
                  : '',
              },
              {
                Condition: 'RecordDate',
                Keyword: this.searchData.RecordDate
                  ? this.searchData.RecordDate.join(',')
                  : '',
              },
              { Condition: 'WorkOrderType', Keyword: this.workOrderType },
            ],
          }
        )
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
            this.pagination.total = resJson.Total
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.clearSelection()
              }
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('提报故障')
    },
    handleSubmit(row) {
      this.$confirm(`此操作将提报故障到工单, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/Base_DeviceTreeManage/Device_Fault/SubmitFaultData', {
              id: row.Id,
            })
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('提报成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该故障单, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post(
              '/Base_DeviceTreeManage/Device_Fault/DeleteDeviceFaultData',
              ids
            )
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('删除成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.$refs.ViewForm.openForm(
        '工单详情',
        {
          Id: row.WorkOrderId,
        },
        true
      )
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {
    ...mapState(['devTreeSearch']),
  },
  watch: {
    devTreeSearch() {
      this.handleSearch()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
